import { render, staticRenderFns } from "./PaymentPricingTable.vue?vue&type=template&id=bfd4a8ca"
import script from "./PaymentPricingTable.vue?vue&type=script&lang=js"
export * from "./PaymentPricingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports